import React from 'react';
export function Team() {
  const team = [{
    name: 'Nahuel',
    role: 'Barbero',
    image: 'https://images.unsplash.com/photo-1622286342621-4bd786c2447c?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    position: 'object-center'
  }, {
    name: 'Micaela',
    role: 'Barbera',
    image: 'https://cdn.magicpatterns.com/uploads/niZDmPuENQZg5qxkhPjBZC/banner_original.png',
    position: 'object-[75%_center]'
  }, {
    name: 'Bruno',
    role: 'Profesor',
    image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    position: 'object-center'
  }];
  return <section className="w-full py-20 px-4 bg-[#111111]" data-id="element-94">
      <div className="max-w-6xl mx-auto" data-id="element-95">
        <h2 className="font-display text-4xl md:text-5xl font-bold text-center mb-16 uppercase tracking-wide" data-id="element-96">
          Nuestro <span className="text-gold" data-id="element-97">Equipo</span>
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-98">
          {team.map((member, index) => <div key={index} className="flex flex-col items-center" data-id="element-99">
              <div className="w-48 h-48 rounded-full border-4 border-gold mb-6 bg-[#222222] flex items-center justify-center overflow-hidden" data-id="element-100">
                <img src={member.image} alt={`Foto de ${member.name}`} className={`w-full h-full object-cover ${member.position}`} data-id="element-101" />
              </div>
              <h3 className="font-display text-2xl font-bold uppercase" data-id="element-102">
                {member.name}
              </h3>
              <p className="text-gold uppercase tracking-widest text-sm mt-2" data-id="element-103">
                {member.role}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}